export default __webpack_public_path__ + "static/media/imagem-dados.ea74af28.png";